import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=09187608&scoped=true&"
import script from "./DetailDialog.vue?vue&type=script&lang=ts&"
export * from "./DetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DetailDialog.vue?vue&type=style&index=0&id=09187608&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09187608",
  null
  
)

export default component.exports